/**
 * Get the current date in a long string format
 * Eg: 1 March 2024
 * @returns String
 */
export const getLongDateStr = () => {
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'long',
  }).format(new Date());
};